import { Dispatch } from "react";
import { Action } from "redux";
import { Environments, GetBandDetail } from "@emisgroup/cohort-builder-kit";
import { ErrorAlertSlice } from "../../../ErrorAlert/Index";
import { ProgressSpinnerSlice } from "../../../ProgressSpinner/Index";
import { OutputMappingChild, OutputMappingItem } from "./OutputMappingList/Types";

/**
 * To fetch the banding details
 * @param configId configuration ID
 * @param bandType Banding type
 * @param translate Translator function
 * @param dispatch Dispatcher function
 * @returns the response
 */
export const FetchBandingDetails = async (
  configId: string,
  bandType: string,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  dispatch: Dispatch<Action>,
  env: Environments,
  accessToken: string
): Promise<any> => {
  const dataSelectorForBandTypes = {
    "age": "ageBand",
    "gender": "genderBand",
    "ethnicity": "ethnicityBand"
  };

  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.BandingDetails")));
    const res = await GetBandDetail(configId, env, accessToken, bandType);
    if (res && res["data"]) {
      const bandResponse = res["data"]["payload"][dataSelectorForBandTypes[bandType]];
      if (bandResponse) {
        dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
        return bandResponse;
      }
    }
  } catch (ex) {
    dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    dispatch(ErrorAlertSlice.actions.showAlert(true));
  }
};

/**
 * To filter the mapping children based on the band type
 * @param dataSource List of output mapping child
 * @param bandType Banding type
 * @returns the filtered mapping child
 */
export const FilterChildrensBasedOnBand = (
  dataSource: OutputMappingChild[],
  bandType: string
): OutputMappingChild[] => {
  return dataSource?.filter((item: OutputMappingChild) => {
    return item.bandType === bandType;
  });
};

// Note: Temporary fix dropdown menu, need to verify once the dropdmenu for the ui package issue is fixed
/**
 * To verify if the mapping has children or not
 * @param outputMappingList - output mapping list
 * @returns first children of mapping list
 */
export const checkIfOutputMappingHasChildItem = (
  outputMappingList: OutputMappingItem[],
  childMapping: OutputMappingItem[]
): OutputMappingItem[] => {
  outputMappingList.forEach((mappingListItem: OutputMappingItem): OutputMappingItem | void => {
    if(mappingListItem.childrenOutputElements && mappingListItem.childrenOutputElements.length > 0)
      childMapping.push(mappingListItem);
  });
  return childMapping;
};
